<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NKqRYj/tc-custom/9780830887415.jpg?1696363259861" alt="This image is the cover for the book Mere Science and Christian Faith"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mere Science and Christian Faith
      </h1>
      <p class="bookDescription body article font2">
        <p>Many Christians have been brought up under the assumption that mainstream science is incompatible with genuine Christian faith—so when they see compelling evidence for biological evolution, for example, they feel forced to choose between science and their faith. The devastating effects of this dilemma are plain to see, as emerging adults either leave the faith or shut themselves off to the findings of the scientific community. But it's a false dilemma. In this book, Greg Cootsona argues against the idea that science and faith are inherently antagonistic. We don't have to keep them scrupulously separated—instead, we can bring them into dialogue with one another. Cootsona brings this integration to a number of current topics in science and faith conversations, including hermeneutics, the historical Adam and Eve, cognitive science, and the future of technology. His insights are enhanced by his work with Fuller Seminary's STEAM research project. Emerging adults want to believe that science and faith can coexist peacefully.<em>Mere Science and Christian Faith</em> holds out a vision for how that integration is possible and how it can lead us more deeply into the conversations around science and faith that confront the church today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Greg Cootsona
      </h2>
      
      <p class="authorDescription body article"><p>Greg Cootsona (PhD, Graduate Theological Union) is a writer, researcher, and speaker. He directs Science and Theology for Emerging Adult Ministries (or STEAM) at Fuller Theological Seminary, and teaches religious studies and humanities at California State University at Chico. He previously served as a pastor for eighteen years in Chico, California, and New York City. He has been interviewed by CNN, the BBC, the <em>New York Times</em>, and the <em>Today Show</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Intervarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69f046b7